import { registerWeapon } from './registry';
import { DEFAULT_CRATER } from '../terrain/crater-shapes';
import { clearCircle, isPointInTerrain, applyScorch } from '../terrain/grid';
import { spawnSmoothingRegion } from '../terrain/sand-physics';

export const DRILL = registerWeapon({
  id: 'drill',
  name: 'Drill',
  description: 'Carves through terrain. Only explodes on direct tank hit.',
  tier: 'UNCOMMON',
  rarity: 'uncommon',
  projectileRadius: 5,
  projectileSpeed: 0.60,
  color: 0xaaaa00,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 35,
  blastRadius: 90,
  knockbackMult: 0.08,
  knockbackRadius: 1.2,
  shakeIntensity: 2.5,
  particleScale: 1.3,
  craterShape: DEFAULT_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.3,
  onTick(proj, state, fx) {
    // Always ignore terrain — drill passes through
    proj.ignoreTerrain = true;
    // Carve terrain each frame if inside
    if (isPointInTerrain(proj.x, proj.y, true)) {
      const carveRadius = 18;
      const bounds = clearCircle(proj.x, proj.y, carveRadius, true, 0.3);
      if (bounds) {
        applyScorch(proj.x, proj.y, carveRadius);
        fx.push({ type: 'terrain_update', bounds });
        spawnSmoothingRegion(state, bounds);
        fx.push({ type: 'particles', method: 'spawnTerrainDebris', args: [proj.x, proj.y, carveRadius, 0.3] });
      }
    }
    return null;
  },
});
